import { render, staticRenderFns } from "./DataDialog.vue?vue&type=template&id=3fdefbaa&scoped=true&"
import script from "./DataDialog.vue?vue&type=script&lang=js&"
export * from "./DataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdefbaa",
  null
  
)

export default component.exports